import { SIZE_COMPLIANCE_REPORT } from "constants/action-types";
import { handleActions } from "redux-actions";

const initialState = {
    reportExportId: null,
    isReportGenerating: false,
    reportError: null,
};

interface IState {
    reportExportId: string;
    isReportGenerating: boolean;
    reportError: any;
}

export const sizeCompliance = handleActions(
    {
        [SIZE_COMPLIANCE_REPORT.CREATE.START]: (state: IState): IState => {
            return {
                ...state,
                isReportGenerating: true,
            };
        },
        [SIZE_COMPLIANCE_REPORT.CREATE.COMPLETED]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    reportError: payload,
                    reportExportId: null,
                    isReportGenerating: false,
                };
            }

            return {
                ...state,
                reportExportId: payload,
                isReportGenerating: false,
            };
        },
        [SIZE_COMPLIANCE_REPORT.CLEAR_REPORT_DATA]: (): IState => {
            return initialState;
        },
    },
    initialState
);
